// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextDay as fn } from "../nextDay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextDayWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default nextDayWithOptions;
